export default __webpack_public_path__ + "static/media/base-2-min.a53dac64.jpg";